import { Components, Theme } from '@mui/material'

declare module '@mui/material/TextField' {
  interface BaseTextFieldProps {
    'data-is-ai-prefilled'?: boolean
  }
}
export const MuiTextField: Components<Omit<Theme, 'components'>>['MuiTextField'] = {
  defaultProps: {
    variant: 'outlined',
  },
  styleOverrides: {
    root: ({ 'data-is-ai-prefilled': dataIsAiPrefilled, theme }) => ({
      '& .MuiOutlinedInput-root': {
        backgroundColor: dataIsAiPrefilled ? theme.palette.secondary.light : theme.palette.neutralLight[0],
        '&.Mui-disabled': {
          backgroundColor: theme.palette.neutralLight[50],
        },
      },
    }),
  },
}
